module.exports = __webpack_public_path__ + "static/media/Smaragdenia_Filaki_1.db6b6cbf.jpg";